import Markdown from "markdown-to-jsx";

// Definir las acciones disponibles para enlaces con hash
const hashActions: Record<string, () => void> = {
    "delete-account": () => {
        console.log("Acción: Eliminar cuenta");
        // Aquí implementar la lógica para eliminar cuenta
    },
    logout: () => {
        console.log("Acción: Cerrar sesión");
        // Aquí implementar la lógica para cerrar sesión
    },
    "contact-support": () => {
        console.log("Acción: Contactar soporte");
        // Aquí implementar la lógica para contactar soporte
    },
    // Agregar más acciones según sea necesario
};

export const makrdownOptions = {
    overrides: {
        a: {
            component: ({ children, href, ...props }: any) => {
                // Verificar si el href contiene un hash
                if (href?.startsWith("#")) {
                    const hashValue = href.substring(1); // Remover el #
                    const action = hashActions[hashValue];

                    if (action) {
                        // Si existe una acción para este hash, comportarse como botón
                        return (
                            <button
                                {...props}
                                onClick={(e) => {
                                    e.preventDefault();
                                    action();
                                }}
                                style={{
                                    textDecoration: "underline",
                                    background: "none",
                                    border: "none",
                                    color: "inherit",
                                    cursor: "pointer",
                                    padding: 0,
                                    font: "inherit",
                                }}
                            >
                                {children}
                            </button>
                        );
                    }
                }

                // Comportamiento normal para enlaces sin hash o hash no reconocido
                return (
                    <a
                        {...props}
                        href={href}
                        style={{ textDecoration: "underline" }}
                    >
                        {children}
                    </a>
                );
            },
        },
    },
};

interface MarkdownCustomProps {
    children: string;
    onHashAction?: (action: string) => void; // Prop opcional para manejar acciones externamente
}

export const MarkdownCustom = ({
    children,
    onHashAction,
}: MarkdownCustomProps) => {
    // Si se proporciona onHashAction, actualizar las acciones
    if (onHashAction) {
        const customOptions = {
            ...makrdownOptions,
            overrides: {
                ...makrdownOptions.overrides,
                a: {
                    component: ({ children, href, ...props }: any) => {
                        if (href?.startsWith("#")) {
                            const hashValue = href.substring(1);

                            return (
                                <button
                                    {...props}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onHashAction(hashValue);
                                    }}
                                    style={{
                                        textDecoration: "underline",
                                        background: "none",
                                        border: "none",
                                        color: "inherit",
                                        cursor: "pointer",
                                        padding: 0,
                                        font: "inherit",
                                    }}
                                >
                                    {children}
                                </button>
                            );
                        }

                        return (
                            <a
                                {...props}
                                href={href}
                                style={{ textDecoration: "underline" }}
                            >
                                {children}
                            </a>
                        );
                    },
                },
            },
        };

        return <Markdown options={customOptions}>{children}</Markdown>;
    }

    return <Markdown options={makrdownOptions}>{children}</Markdown>;
};
